export default __webpack_public_path__ + "static/media/altar.d50fb95d.png";